import { SgAuxRouteBridgeService, SgAuxRouteBridgeOutletController } from '@sg/ui-kit/aux-route-bridge';
import { MatDrawerAuxRouteOutletDirective } from './mat-drawer-aux-route-outlet.directive';

/**
 * Base class for services that want to control the MatDrawerAuxRouteOutletDirective.
 * These services will usually include helper methods that use the SgAuxRouter and provide easy access to aux-routes.
 */
export abstract class SgAuxMatDrawerController extends SgAuxRouteBridgeOutletController<MatDrawerAuxRouteOutletDirective> {
  constructor(bridge: SgAuxRouteBridgeService, outletName: string) {
    super(bridge, outletName, MatDrawerAuxRouteOutletDirective);
  }
}
